<script setup>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Load user data
const authStore = useAuthStore()
const { userStatus } = storeToRefs(authStore)
const { updateUserStatus } = authStore

/**
 * Resets the status object with the given value.
 *
 * @param {any} value - The new value to set the status object to.
 * @return {void} This function does not return anything.
 */
const resetStatusObj = (value) => {
    updateUserStatus(value)
}

// Fade message out + go to account after 3 seconds
watchEffect(() => {
    if (userStatus.value?.success) {
        // Hide message
        setTimeout(() => {
            updateUserStatus(null)
        }, 2000)
    }
})
</script>

<template>
    <SideBarWrapper>
        <FormMessage :form-message-config="userStatus" @update:set-status="resetStatusObj" />

        <SideBarHeader>
            <SideBarMainHeadline :sidebar-main-headline-config="{ title: staticKeys?.menu_personaldata_markdown }" />
        </SideBarHeader>

        <SideBarHeadline :sidebar-headline-config="{ title: staticKeys?.account_menu_personal_headline, asterisk: staticKeys?.account_form_asterisk }" />

        <UserAccountPersonalData />
    </SideBarWrapper>
</template>
